// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
// import { createSlice } from '@reduxjs/toolkit';
// // utils
// import axios from '../../utils/axios';
// const backendUrl = process.env.REACT_APP_BACKEND_URL;
// // ----------------------------------------------------------------------

// const initialState = {
//   isLoading: false,
//   error: null,
//   choiceGroups: [],
//   choiceGroup: null
// };

// const slice = createSlice({
//   name: 'choiceGroup',
//   initialState,
//   reducers: {
//     // START LOADING
//     startLoading(state) {
//       state.isLoading = true;
//     },

//     // HAS ERROR
//     hasError(state, action) {
//       state.isLoading = false;
//       state.error = action.payload;
//     },

//     // GET CATEGORIES
//     getChoiceGroupsSuccess(state, action) {
//       state.isLoading = false;
//       state.choiceGroups = JSON.parse(JSON.stringify(action.payload));
//     },

//     reRenderGroupsSuccess(state, action) {
//       state.choiceGroup.map((cg) => {
//         if(cg.id === action.payload) {
//           cg.selected = true;
//         }
//       });
//     },

//     // GET CATEGORY
//     getChoiceGroupSuccess(state, action) {
//       state.isLoading = false;
//       state.choiceGroup = JSON.parse(JSON.stringify(action.payload));
//     },
//   },
// });

// // Reducer
// export default slice.reducer;

// // Actions
// // export const {
// // } = slice.actions;

// // ----------------------------------------------------------------------

// export function getChoiceGroups(levelId, venueId) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(`${backendUrl}/choiceGroups?levelId=${levelId}&venueId=${venueId}&limit=100000`);
//       dispatch(slice.actions.getChoiceGroupsSuccess(response.data.results));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

// // ----------------------------------------------------------------------

// export function reRenderChoiceGroups(id) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       dispatch(slice.actions.reRenderGroupsSuccess(id));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

// // ----------------------------------------------------------------------

// export function getChoiceGroup(choiceGroupId) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(`${backendUrl}/choiceGroups/${choiceGroupId}`);
//       dispatch(slice.actions.getChoiceGroupSuccess(response.data));
//     } catch (error) {
//       console.error(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }




import { createSlice } from "@reduxjs/toolkit";
import {
  getLocalizedText,
  getResolvedId,
  apiGet,
  getResults,
  getResource,
  handleApiRequest,
} from "../../utils/apiRequestV2";

const CHOICE_GROUP_ENDPOINT = "/venue/choice-group";
const TERMINAL_CHOICE_GROUP_ENDPOINT =
  "/venue/choice-group/terminal-choice-groups";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  choiceGroups: [],
  choiceGroup: null,
};

const slice = createSlice({
  name: "choiceGroup",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getChoiceGroupsSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroups = JSON.parse(JSON.stringify(action.payload));
    },

    reRenderGroupsSuccess(state, action) {
      state.choiceGroups = state.choiceGroups.map((cg) => {
        if (cg.id === action.payload || cg._id === action.payload) {
          return {
            ...cg,
            selected: true,
          };
        }

        return cg;
      });
    },

    getChoiceGroupSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroup = JSON.parse(JSON.stringify(action.payload));
    },
  },
});

export default slice.reducer;

// ----------------------------------------------------------------------

const buildListParams = (venueId, params = {}) => ({
  venueId,
  ...params,
});

const normalizeChoiceGroupItem = (item) => {
  const id = getResolvedId(item);
  const name = getLocalizedText(
    item?.name || item?.item || item?.product?.name,
    ""
  );

  return {
    ...item,

    id,
    _id: item?._id || id,

    item: name,
    name,

    price: item?.extraPrice ?? item?.price ?? "0",
    extraPrice: item?.extraPrice ?? item?.price ?? "0",
    foodPandaPrice: item?.foodPandaPrice ?? "0",
    quantity: item?.quantity ?? "1",

    selected: item?.selected || item?.isDefaultSelected || false,
  };
};

const normalizeChoiceGroup = (choiceGroup) => {
  const id =
    getResolvedId(choiceGroup?.choiceGroupId) ||
    getResolvedId(choiceGroup?.choiceGroup) ||
    getResolvedId(choiceGroup);

  const items = Array.isArray(choiceGroup?.items)
    ? choiceGroup.items.map(normalizeChoiceGroupItem)
    : [];

  const status = choiceGroup?.scope?.status || choiceGroup?.status || "active";

  return {
    ...choiceGroup,

    id,
    _id: choiceGroup?._id || id,

    name: getLocalizedText(choiceGroup?.name, ""),
    description: getLocalizedText(choiceGroup?.description, ""),

    quantity: choiceGroup?.selectionQuantity ?? choiceGroup?.quantity ?? 1,
    selectionQuantity:
      choiceGroup?.selectionQuantity ?? choiceGroup?.quantity ?? 1,

    status,

    // V2 response mein abhi items/options nahi aa rahe.
    // Empty required group add-to-cart block na kare is liye false.
    required: items.length > 0 ? choiceGroup?.required || false : false,

    items,
  };
};

// ----------------------------------------------------------------------

export function getChoiceGroups(venueId, params = {}) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        const response = await apiGet(
          TERMINAL_CHOICE_GROUP_ENDPOINT,
          buildListParams(venueId, params)
        );

        const choiceGroups = getResults(response)
          .map(normalizeChoiceGroup)
          .filter((choiceGroup) => choiceGroup.status === "active");

        dispatch(slice.actions.getChoiceGroupsSuccess(choiceGroups));

        return {
          status: 200,
          data: choiceGroups,
        };
      },
    });
}

// ----------------------------------------------------------------------

export function reRenderChoiceGroups(id) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        dispatch(slice.actions.reRenderGroupsSuccess(id));

        return {
          status: 200,
        };
      },
    });
}

// ----------------------------------------------------------------------

export function getChoiceGroup(choiceGroupId, venueId, params = {}) {
  return async (dispatch) =>
    handleApiRequest({
      dispatch,
      startLoading: slice.actions.startLoading,
      hasError: slice.actions.hasError,
      request: async () => {
        const response = await apiGet(`${CHOICE_GROUP_ENDPOINT}/${choiceGroupId}`, {
          venueId,
          status: "active",
          // channel: "POS",
          ...params,
        });

        const choiceGroup = getResource(response, "choiceGroup");
        const normalizedChoiceGroup = normalizeChoiceGroup(choiceGroup);

        dispatch(slice.actions.getChoiceGroupSuccess(normalizedChoiceGroup));

        return {
          status: 200,
          data: normalizedChoiceGroup,
        };
      },
    });
} 
